module.exports = __webpack_public_path__ + "static/media/AngleUpIcon_Light.aa0b97de.svg";